import { ArrowRightIcon } from "@phosphor-icons/react/dist/csr/ArrowRight";
import { Link } from "react-router-dom";
import { Text } from "@volca/ui/components/ui/text";

/** A quiet "see more" link with a trailing arrow. */
export const DashboardLink = ({ to, label }: { to: string; label: string }) => (
  <Link
    to={to}
    className="group inline-flex items-center gap-1 rounded-md text-subtle transition-colors hover:text-ink focus-visible:ring-2 focus-visible:ring-focus focus-visible:outline-hidden"
  >
    <Text tone="muted" className="group-hover:text-ink">
      {label}
    </Text>
    <ArrowRightIcon size={14} aria-hidden="true" />
  </Link>
);
